/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const userProfileCardSchema = z.object({
	id: z.uuid(),
	first_name: z.string(),
});
